// The tool's own name (sidebar, sign-in screen, browser tab). Kept in the data
// (settings.appName, so it syncs) and mirrored in localStorage so the sign-in
// screen can show it before the encrypted data is opened.
export const DEFAULT_APP_NAME = "Invoice Studio";
const KEY = "invoice-studio-app-name";

export function storedAppName() {
  try {
    return localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function rememberAppName(name) {
  try {
    if (name) localStorage.setItem(KEY, name);
    else localStorage.removeItem(KEY);
  } catch {
    /* private mode */
  }
}

export function resolveAppName(store) {
  // the sign-in screen only renders in the browser, so reading storage there is safe;
  // elsewhere wait for the data to load (keeps server and browser HTML identical)
  if (store?.locked) return storedAppName() || DEFAULT_APP_NAME;
  if (!store?.ready) return DEFAULT_APP_NAME;
  return String(store.settings?.appName || "").trim() || DEFAULT_APP_NAME;
}
